import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 11l4 4 7-7-4-4-7 7z" />
    <path d="M4 20h9" />
    <path d="M5 19l4-8" />
  </svg>
);

const HighlightIcon = (props) => <Icon component={SVG} {...props} />;

export default HighlightIcon;
